<div class="modal-content">
  <div class="modal-body text-center modal-aviso-cpf-invalido__body">
    <div class="modal-aviso-cpf-invalido__subtitle">{{ message }}</div>
    <section class="modal-aviso-cpf-invalido__content">
      <img src="../../../../../assets/images/verify_valid_user.svg" alt="videocam">
    </section>
  </div>
  <div class="modal-footer modal-aviso-cpf-invalido__action">
    <app-gradient-button
      label="DIGITAR NOVAMENTE"
      (click)="close()">
    </app-gradient-button>
  </div>
</div>
